


export const isInApp = () => {
  try {
    if (typeof (window) === "undefined") {
      return false;
    }

    return window.navigator.standalone || !window.matchMedia('(display-mode: browser)').matches;
  } catch (err) {
    console.error("Error determining if currently running in-app")
    return false;
  }

};
